import { useEffect } from 'react';

const useSetFocusGroup = (name, activeGroup) => {
  useEffect(() => {
    let timer;

    if (name === activeGroup) {
      // Find the next logical element to focus
      const [focusEl] = [
        ...document.querySelectorAll(
          'fieldset.active legend, fieldset.active .content, fieldset.active label, legend, .content, label',
        ),
      ].filter((el) => el.innerText !== '');

      if (focusEl) {
        timer = setTimeout(() => {
          focusEl.setAttribute('tabIndex', -1);
          focusEl.focus();
        }, 510);
      }
    }

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeGroup]);
};

export default useSetFocusGroup;
